<template>
  <generic-modal
    :is_wide="true"
    :title="$t('inventory movement')"
    ref="generic_modal"
  >
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('movement type')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/inventory/movement_type/catalog"
              name_field="name"
              value_field="uuid"
              @selected="set_movement_type"
              ref="movement_type_dropdown"
            />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('warehouse')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/inventory/warehouse/catalog"
              name_field="name"
              value_field="uuid"
              @selected="set_warehouse"
              ref="warehouse_dropdown"
            />
          </div>
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t("comment") }}</label>
        <textarea
          class="textarea"
          v-model="meta.comment"
          cols="30"
          rows="2"
        ></textarea>
      </div>
      <div class="box mt-0">
        <div class="columns">
          <div class="column is-5">
            <h1 class="title is-4">{{ $t("products") }}</h1>
          </div>
          <div class="column is-7">
            <div class="buttons is-pulled-right">
              <div class="button is-secondary is-rounded" @click="add_item">
                <span class="icon"><i class="fa fa-plus"></i></span>
                <span>{{ $t("add") }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="table-container" ref="tc">
          <table
            class="table is-striped is-hoverable mb-6"
            ref="table"
            style="width: 100%"
          >
            <thead>
              <tr>
                <th width="20%">{{ $t("quantity") }}</th>
                <th>{{ $t("product") }}</th>
                <th>{{ $t("setings") }}</th>
                <th>{{ $t("options") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, pidx) in meta.items" :key="pidx">
                <td>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input
                        type="text"
                        class="input"
                        v-model="meta.items[pidx].quantity"
                        :placeholder="$t('sale')"
                      />
                      <span class="icon is-small is-left">
                        <i class="fa fa-cubes"></i>
                      </span>
                    </p>
                  </div>
                </td>
                <td class="pt-0">
                  <div class="field">
                    <generic-dropdown
                      title=""
                      :placeholder="$t('select one')"
                      :is_multiple="false"
                      url="/product/catalog"
                      name_field="name"
                      value_field="product_id"
                      @selected="meta.items[pidx].product = $event"
                      ref="product_dropdown"
                    />
                  </div>
                </td>
                <td>{{ item.settings }}</td>
                <td>
                  <p class="buttons">
                    <a
                      class="button"
                      :data-tooltip="$t('configure')"
                      @click="configure_item(item)"
                    >
                      <span class="icon has-text-info">
                        <i class="fa fa-cogs"></i>
                      </span>
                    </a>
                    <a
                      class="button"
                      :data-tooltip="$t('delete')"
                      @click="meta.items.splice(pidx, 1)"
                    >
                      <span class="icon has-text-danger">
                        <i class="fa fa-trash"></i>
                      </span>
                    </a>
                  </p>
                </td>
              </tr>
            </tbody>
            <tfoot></tfoot>
          </table>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import { put, post, generate_error_message_text } from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "InventoryMovementModal",
  components: { GenericModal, GenericDropdown },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return (
        !v.meta.movement_type_id ||
        !v.meta.items ||
        !v.meta.items.length ||
        !v.meta.warehouse_id
      );
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let data = { ...v.meta };
      put("/inventory/movement", data)
        .then(() => {
          v.$emit("success");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.provider_uuid = undefined;
      v.meta = {
        movement_type_id: "",
        comment: "",
        items: [],
      };
      v.$refs.movement_type_dropdown.clear();
      v.$refs.warehouse_dropdown.clear();
      v.error = "";
    },
    set_movement_type(value) {
      let v = this;
      if (value) v.meta.movement_type_id = value.movement_type_id;
    },
    set_warehouse(value) {
      let v = this;
      if (value) v.meta.warehouse_id = value.warehouse_id;
    },
    add_item() {
      let v = this;
      v.meta.items.push({ quantity: 1, product: { name: "" }, settings: {} });
    },
    configure_item(item) {
      // let v = this;
      console.log("item", item);
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
